import styled from '@emotion/styled';
import mixpanel from 'mixpanel-browser';

import { PlanGroup } from '@d-id/types';

import { pricingPageUrl } from '@/environment';
import { useAuth } from '@/services/auth';
import { ERROR_KINDS } from '@/state/layout/moderation';

interface Props {
    kind: (typeof ERROR_KINDS)[keyof typeof ERROR_KINDS];
}

const ModerateableContainer = styled.div<{ isModerateable: boolean }>`
    display: ${({ isModerateable }) => (isModerateable ? 'block' : 'none')};
    color: ${({ theme }) => theme.colors.black.main};
    margin: 1.4rem 0;
`;

const UpgradeText = styled.span`
    color: ${({ theme }) => theme.colors.links.main} !important;
    font-weight: bold !important;
    margin-left: 5px;
    cursor: pointer;
`;

const Container = styled.div`
    & span {
        text-decoration: none !important;
    }
`;

export default function ({ kind }: Props) {
    const { user } = useAuth();
    const onUpgradeClick = () => {
        mixpanel?.track('upgrade', {
            from: 'image-moderation',
            event: 'click',
            kind,
        });
        window.open(pricingPageUrl, '_blank');
    };
    const canRequestModerate =
        user?.planGroup && [PlanGroup.ENTERPRISE, PlanGroup.ENTERPRISE_TRIAL, PlanGroup.ADVANCED, PlanGroup.SCALE].includes(user.planGroup);

    return (
        <Container>
            <ModerateableContainer isModerateable={!canRequestModerate}>
                Request a review by
                <UpgradeText onClick={onUpgradeClick}>upgrading to Advanced plan</UpgradeText>
            </ModerateableContainer>
        </Container>
    );
}
